import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/erasmus.png'


const _withScopeId = n => (_pushScopeId("data-v-2b8fd35c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "project-subheading" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode("Academic Network for a "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Green & Innovative Europe")
  ])
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "project-heading" }, [
  /*#__PURE__*/_createElementVNode("span", null, "ANGIE")
], -1))
const _hoisted_3 = { class: "image-text" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "2023-1-RO01-KA220-HED-000158031", -1))

import HomePagePartnersSection from "../components/HomePagePartnersSection.vue";
import BecomeAMemberSection from "@/components/BecomeAMemberSection.vue";
import NewsSection from "@/components/NewsSection.vue";
import AboutSection from "@/components/AboutSection.vue";
import PhotoCarroussel from "../components/PhotoCarroussel.vue";
import angiePhoto from "../assets/images/regen/angie.png";
import angieMobilePhoto from "../assets/images/regen/angie_mobile.png";
import { ref } from "vue";
import { watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const selectedImage = ref(
  window.innerWidth >= 1200 ? angiePhoto : angieMobilePhoto
);

const isMobile = ref(window.innerWidth < 1200);

watch(
  () => window.innerWidth,
  (width) => {
    if (width >= 1200) {
      selectedImage.value = angiePhoto;
    } else {
      selectedImage.value = angieMobilePhoto;
    }
  }
);

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_img, {
      alt: "photo",
      src: selectedImage.value
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_v_img, {
            src: _imports_0,
            alt: "Erasmus",
            class: "image"
          }),
          _hoisted_4
        ])
      ]),
      _: 1
    }, 8, ["src"]),
    _createVNode(BecomeAMemberSection, { isMobile: isMobile.value }, null, 8, ["isMobile"]),
    _createVNode(HomePagePartnersSection),
    _createVNode(AboutSection),
    _createVNode(NewsSection),
    _createVNode(PhotoCarroussel)
  ], 64))
}
}

})